var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoldenArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 13,
    viewBox: "0 0 7 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-1.88549e-06 10.6488L4.32658 6.03333L-2.51043e-07 1.41783L1.33198 2.30116e-07L7 6.03333L1.33198 12.0667L-1.88549e-06 10.6488Z",
    fill: "#C7922F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldenArrow);
export default __webpack_public_path__ + "static/media/goldenArrow.6632e32c00936e49bc1ede5030d38988.svg";
export { ForwardRef as ReactComponent };